var _path, _g, _path2, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_474_4567)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_474_4567",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0153809 0.0423584H23.8883V23.9714H0.0153809V0.0423584Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_474_4567)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8883 12.0068C23.8883 18.6147 18.5442 23.9713 11.9518 23.9713C5.3595 23.9713 0.0153809 18.6147 0.0153809 12.0068C0.0153809 5.39892 5.3595 0.0422363 11.9518 0.0422363C18.5442 0.0422363 23.8883 5.39892 23.8883 12.0068Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_474_4567",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0408 0.0419922C18.6267 0.0496388 23.9633 5.4035 23.9633 12.0067L23.9617 12.2045C23.8563 18.7211 18.5531 23.9712 12.0267 23.9712L11.8293 23.9696C5.32807 23.8639 0.090332 18.5484 0.090332 12.0067L0.0919312 11.8088C0.197339 5.29218 5.50035 0.0419922 12.0267 0.0419922H12.0126H12.0408Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_474_4567)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.34841 9.0668C7.6945 8.71996 8.15478 8.52898 8.64419 8.52898C9.13365 8.52898 9.59365 8.71996 9.94002 9.0668L12.1 11.2323L14.2604 9.06702V9.0668C14.6064 8.71996 15.0667 8.52898 15.5557 8.52898C16.0453 8.52898 16.5055 8.71996 16.8516 9.06702C17.5659 9.78303 17.5659 10.948 16.8516 11.6641L12.1 16.4266L7.34841 11.6642C6.6341 10.948 6.6341 9.78303 7.34841 9.0668ZM20.2303 25.058H17.2989L14.1927 29.2359H13.3053V18.5451L18.5108 13.3273C20.1401 11.6941 20.1401 9.03677 18.5108 7.40373C17.7218 6.61254 16.6721 6.17676 15.5557 6.17676C14.4398 6.17676 13.3905 6.61243 12.6012 7.40363L12.1 7.90582L11.5992 7.40363C10.8098 6.61243 9.76024 6.17676 8.64419 6.17676C7.5279 6.17676 6.47827 6.61254 5.68926 7.40363C4.05996 9.03677 4.05996 11.6941 5.68926 13.3275L10.8716 18.5218V35.409H13.3053V31.507H14.4953L17.3258 35.409H20.2706L16.4045 30.139L20.2303 25.058Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_474_4567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.5cf2c8013d6d9cab74e74897ed29c7ee.svg";
export { ForwardRef as ReactComponent };